import { createContext, type ReactNode, useContext, useState } from 'react'

type frontImageType = 'standard' | 'reverse'

interface CategoriesGridContextType {
  frontImage: frontImageType
  setFrontImage: (image: frontImageType) => void
}

const CategoriesGridContext = createContext<
  CategoriesGridContextType | undefined
>(undefined)

export const CategoriesGridProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [frontImage, setFrontImage] =
    useState<CategoriesGridContextType['frontImage']>('standard')

  return (
    <CategoriesGridContext.Provider value={{ frontImage, setFrontImage }}>
      {children}
    </CategoriesGridContext.Provider>
  )
}

export const useCategoriesGrid = () => {
  const context = useContext(CategoriesGridContext)

  if (!context) {
    throw new Error(
      'useCategoriesGrid must be used within a CategoriesGridProvider',
    )
  }

  return context
}
